<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem [disabled]="isDistributorRole" (click)="onEditGateway()">
      <span class="fa-solid fa-gear"></span>
      <span translate>Details</span>
    </button>
    @if (gateway !== null && (gateway.cloudplugType === gatewayType.CPONE || gateway.cloudplugType === gatewayType.CPEDGE)) {
      <button ngbDropdownItem
        [disabled]="!gateway.usingSharedSecretKey || (!isTechAdminRole && !isSuperAdminRole)"
        (click)="onResetSharedKey()">
        <span class="fa-solid fa-circle-exclamation"></span>
        <span translate>Reset secret key</span>
      </button>
    }
    <button ngbDropdownItem #deleteButton [disabled]="(!isTechAdminRole && !isSuperAdminRole)"
      [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}" (click)="onDeleteGateway()">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span>
    </button>
  </div>
</div>